import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import {
    workflowsPath,
    workflowCreatePath,
    welcomePagePath,
    profilePagePath,
    newWorkflowCreatePath,
    dataPagePath,
    uploadDataPagePath,
    uploadDatasetDetailsPath,
    uploadDatasetUpadatePath,
    uploadDatasetFileListPath,
    uploadDatasetFilePath,
    workflowDatasetsPagePath,
    workflowUploadDatasetDetailsPath,
    workflowUploadDatasetUpadatePath,
    workflowUploadDatasetFileListPath,
    workflowUploadDatasetFilePath,
} from './paths';

const Data = Loadable(lazy(() => import('pages/Datasets/Data')));
const UploadDataset = Loadable(lazy(() => import('pages/Datasets/UploadDataset')));
const DataSetDetails = Loadable(lazy(() => import('pages/Datasets/dataSetDetails')));
const UpdateDatasetMetadata = Loadable(lazy(() => import('pages/Datasets/dataSetDetails/updateDatasetMetadata')));
const FileList = Loadable(lazy(() => import('pages/Datasets/dataSetDetails/fileList')));
const EditFile = Loadable(lazy(() => import('pages/Datasets/dataSetDetails/fileList/fileContent/editFile')));
const WorkflowDatasets = Loadable(lazy(() => import('pages/Datasets/workflowDatasets')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const WelcomePage = Loadable(lazy(() => import('pages/extra-pages/welcome-page')));
const WorkflowsPage = Loadable(lazy(() => import('pages/workflows')));
const WorkflowCreate = Loadable(lazy(() => import('pages/workflows/workflowCreate/WorkflowCreate')));
const NewWorkflowCreate = Loadable(lazy(() => import('pages/workflows/workflowCreate/WorkflowCreate')));
const ProfilePage = Loadable(lazy(() => import('pages/auth/profilePage')));

const NotFoundPage = Loadable(lazy(() => import('pages/maintenance/NotFoundPage')));

const MainRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <AuthGuard>
                    <MainLayout />
                </AuthGuard>
            ),
            children: [
                {
                    path: welcomePagePath(),
                    element: <WelcomePage />,
                },
                {
                    path: workflowsPath(),
                    element: <WorkflowsPage />,
                },
                {
                    path: workflowCreatePath(),
                    element: <WorkflowCreate />,
                },
                {
                    path: profilePagePath(),
                    element: <ProfilePage />,
                },
                {
                    path: newWorkflowCreatePath(),
                    element: <NewWorkflowCreate />,
                },
                {
                    path: dataPagePath(),
                    element: <Data />,
                },
                {
                    path: uploadDataPagePath(),
                    element: <UploadDataset />,
                },
                {
                    path: uploadDatasetDetailsPath(),
                    element: <DataSetDetails />,
                },
                {
                    path: uploadDatasetUpadatePath(),
                    element: <UpdateDatasetMetadata />,
                },
                {
                    path: uploadDatasetFileListPath(),
                    element: <FileList />,
                },
                {
                    path: uploadDatasetFilePath(),
                    element: <EditFile />,
                },
                {
                    path: workflowDatasetsPagePath(),
                    element: <WorkflowDatasets />,
                },
                {
                    path: workflowUploadDatasetDetailsPath(),
                    element: <DataSetDetails />,
                },
                {
                    path: workflowUploadDatasetUpadatePath(),
                    element: <UpdateDatasetMetadata />,
                },
                {
                    path: workflowUploadDatasetFileListPath(),
                    element: <FileList />,
                },
                {
                    path: workflowUploadDatasetFilePath(),
                    element: <EditFile />,
                },
                {
                    path: '*',
                    element: <NotFoundPage />,
                },
            ],
        },
        {
            path: '/maintenance',
            element: <CommonLayout />,
            children: [
                {
                    path: '404',
                    element: <MaintenanceError />,
                },
                {
                    path: '500',
                    element: <MaintenanceError500 />,
                },
                {
                    path: 'under-construction',
                    element: <MaintenanceUnderConstruction />,
                },
                {
                    path: 'coming-soon',
                    element: <MaintenanceComingSoon />,
                },
            ],
        },
        {
            path: '*',
            element: <NotFoundPage />,
        },
    ],
};

export default MainRoutes;
